import React from 'react';
import { Breadcrumb } from '@shared/components/breadcrumb/Breadcrumb';
import { Page } from '../../layout';
import { getAdjustedBreadcrumbPathItems } from '@shared/services/breadcrumbService';
import { userInfo } from '@apollo-internal/cache';
import { useReactiveVar } from '@apollo/client';
import StrengthsAndChallenges from './StrengthsAndChallenges';

const StrengthsAndChallengesPage = () => {
  const currentUserInfo = useReactiveVar(userInfo);

  const adjustedBreadcrumbPathItems = getAdjustedBreadcrumbPathItems(
    breadcrumbPathItems,
    currentUserInfo.SystemRole.Id
  );

  return (
    <Page title={pageTitle} className='strength-and-challenges'>
      <Breadcrumb pathItems={adjustedBreadcrumbPathItems} />
      <StrengthsAndChallenges title={pageTitle} description={description} />
    </Page>
  );
};

export default StrengthsAndChallengesPage;

const pageTitle = 'Strengths and Challenges';

const description =
  'This report provides the industry Strengths and Challenges. The report can be filtered ' +
  'by selecting one of the views. The report defaults to the Baseline view, ' +
  'which displays the list of practices that were determined to be Strengths or ' +
  'Challenges based on the result from the first instance in which they were evaluated ' +
  '(the first instance may not have occurred in the first year). ' +
  'The delta view allows for a comparison between two instances. ' +
  'Use the delta instance selector to choose which instances to compare. ' +
  'The total view represents Strengths and Challenges across all instances. ' +
  'The OHT(s) selection can be used to filter the results further. ' +
  'If there are not enough results for a practice, then it will not be displayed in the table.';

const breadcrumbPathItems = [
  { name: 'Data Reports', url: '/data-reports' },
  {
    name: 'Industry Reports',
    url: '/data-reports/industry-reports'
  },
  {
    name: pageTitle,
    url: ''
  }
];
